import React from "react";
import Button from "../Buttons";
import { BuyCart } from "../../assets/images";
import styled from "styled-components";
import { checkIfGivenDateNotRestricted } from "../../helper";
import dayjs from "dayjs";

const StickyCart = ({
  onAddToCart,
  amount,
  offerProducts,
  newProductQty,
  cartProductQty,
  isEnabled,
  restrictedDate,
  date,
  dynamicPromotion,
  products
}) => {
  const hasNoRestriction = checkIfGivenDateNotRestricted(
    restrictedDate,
    dayjs(date).format("YYYY-MM-DD")
  );
  const getSum = (array, key) => {
    let sum = 0;
    array.forEach((item) => {
      if (item[key] !== undefined) {
        sum += item[key];
      }
    });
    return sum;
  };

  const totalSum =
    offerProducts?.length > 0
      ? offerProducts?.reduce((acc, key) => {
          return acc + getSum(newProductQty, key);
        }, 0)
      : 0;

  const getEligibleOffer = (totalSum, details = []) => {
    if (!details?.length) return null;

    const sortedDetails = [...details].sort((a, b) => a.minQty - b.minQty);
    let matchedOffer = null;

    for (let offer of sortedDetails) {
      if (totalSum >= offer.minQty) {
        matchedOffer = offer;
      }
    }

    return matchedOffer;
  };

  const getInitialPromoDesc = (
    details = [],
    ticketLabel = "Unlimited tickets"
  ) => {
    if (!details?.length) return "";

    const bestInitialOffer = details.reduce((prev, curr) => {
      return curr.minQty < prev.minQty ? curr : prev;
    }, details[0]);

    const { minQty, freeQty } = bestInitialOffer;
    const paidQty = minQty - freeQty;

    return `Buy ${minQty} ${ticketLabel} (Pay for ${paidQty} – ${
      freeQty > 1 ? `${freeQty} lowest tickets free` : "lowest one free"
    })`;
  };

  const getPromotionOffer = (totalSum, details = []) => {
    if (!details?.length) return null;

    const sortedDetails = [...details].sort((a, b) => a.minQty - b.minQty);

    for (let i = 0; i < sortedDetails.length; i++) {
      const offer = sortedDetails[i];
      if (totalSum < offer.minQty) {
        return offer;
      }
    }

    return sortedDetails[sortedDetails.length - 1];
  };

  const offerToPromote = getPromotionOffer(totalSum, dynamicPromotion?.details);

  const eligibleOffer = getEligibleOffer(totalSum, dynamicPromotion?.details);

  return (
    <StyledStickyCart>
      <StyledStickyCartInner>
        {isEnabled && hasNoRestriction && (
          <>
            {eligibleOffer?.freeQty > 0 ? (
              <div>
                <ItemAddedText>
                  <ItemAddedText>
                    You've earned {eligibleOffer?.freeQty} free ticket!
                  </ItemAddedText>
                </ItemAddedText>

                <WhiteText>
                  Buy {offerToPromote?.minQty} (Pay for{" "}
                  {offerToPromote?.minQty - offerToPromote?.freeQty} –{" "}
                  {offerToPromote?.freeQty} ticket
                  {offerToPromote?.freeQty > 1 ? "s" : ""} free!)
                </WhiteText>
              </div>
            ) : (
              <>
                {totalSum > 0 ? (
                  <div>
                    <ItemAddedText>
                      <ItemAddedText>
                        {totalSum} Unlimited ticket(s) added
                      </ItemAddedText>
                    </ItemAddedText>
                    <WhiteText>
                      Buy {offerToPromote?.minQty} (Pay for{" "}
                      {offerToPromote?.minQty - offerToPromote?.freeQty} –{" "}
                      {offerToPromote?.freeQty} ticket
                      {offerToPromote?.freeQty > 1 ? "s" : ""} free!)
                    </WhiteText>
                  </div>
                ) : (
                  <div>
                    <ItemAddedText>
                      {dynamicPromotion?.promoTitle ||
                        "Add Unlimited Tickets to your cart"}
                    </ItemAddedText>
                    <WhiteText>
                      {dynamicPromotion?.promoDesc ||
                        getInitialPromoDesc(dynamicPromotion?.details || [])}
                    </WhiteText>
                  </div>
                )}
              </>
            )}
          </>
        )}
        <div>
          {isEnabled && hasNoRestriction && (
            <BlackText>
              Total Tickets :{" "}
              {newProductQty.reduce(
                (acc, obj) => acc + Object.values(obj)[0],
                0
              )}
            </BlackText>
          )}
          <BlackText>Total : {amount} QAR</BlackText>
        </div>
        <div>
          <Button
            width="12rem"
            variant="filled"
            endIcon={<BuyIcon src={BuyCart} />}
            label={"Add to Cart"}
            onClick={onAddToCart}
            disabled={products?.length < 1}
          />
        </div>
      </StyledStickyCartInner>
    </StyledStickyCart>
  );
};

const StyledStickyCart = styled.div`
  width: 100vw;
  padding: 1.5rem 0;
  position: sticky;
  bottom: 0;
  background: linear-gradient(180deg, #e956da 0%, #e956da 100%);
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  @media only screen and (max-width: 1240px) {
    padding: 0.5rem 6rem;
  }
`;

const StyledStickyCartInner = styled.div`
  width: 1024px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 876px) {
    flex-direction: column;
    align-items: center;
    gap: 8px;
    > div {
      text-align: center;
    }
  }
`;

const ItemAddedText = styled.div`
  color: white;
  font-weight: 600;
  font-size: 18px;
  @media only screen and (max-width: 576px) {
    font-size: 14px;
  }
`;

const WhiteText = styled.div`
  color: white;
  font-weight: 500;
  @media only screen and (max-width: 576px) {
    font-size: 12px;
  }
`;

const BlackText = styled.div`
  font-weight: 600;
  @media only screen and (max-width: 576px) {
    font-size: 12px;
  }
`;

const BuyIcon = styled.img`
  width: 2rem;
  height: 2rem;
`;

export default StickyCart;
